import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { withFormik, Field } from "formik";
import { useTranslation } from "react-i18next";
import {
  dataModel,
  validationDataModel,
  setInitialValues,
} from "./changePasswordForm.data.form";
// import InputSelect from "../../../utils/InputSelect";
import {
  InputSelect,
  InputCheck,
  InputAutoComplete,
  InputText,
} from "@de-prado-dev/react-component-library";
import { ROLES } from "../../../../constants";
import { Container } from "./changePasswordForm.styled";

const UserForm = (props) => {
  const { t } = useTranslation();
  const {
    handleSubmit,
    onBack,
    edit,
    viveros,
    users,
    onFilterUser,
    onCheckCreate,
    checkCreate,
  } = props;

  const roles = ROLES.map((rol) => {
    return { value: rol, label: t(rol) };
  });

  const renderListUser = (item) => {
    return item.completeName;
  };

  return (
    <>
      <div className="row justify-content-center">
        <div className="col-12 col-md-11 marg-btm-1rem marg-top-40px">
          <h3 className="title">
            { t("forms.users.changePassword") }
          </h3>
        </div>
      </div>
      <div className="row justify-content-center mt-4">
        <div className="col-12 col-md-11">
          <form autoComplete="off" onSubmit={handleSubmit}>
            <div className="row">
              <div className="col-12">
                <Field
                  id="password"
                  className="form-control"
                  labelField={t("forms.users.labels.password")}
                  name="password"
                  mandatory
                  component={InputText}
                  fieldType="password"
                />
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                <Field
                  id="confirmPassword"
                  className="form-control"
                  labelField={t("forms.users.labels.confirmPassword")}
                  name="confirmPassword"
                  mandatory
                  component={InputText}
                  fieldType="password"
                />
              </div>
            </div>
            <div className="row justify-content-center">
              <div className="col-10 col-sm-11 text-center mt-5 mb-5">
                <button
                  type="button"
                  onClick={() => onBack()}
                  className="btn btn-lg btn-primary me-2"
                >
                  {t("forms.users.buttons.cancel")}
                </button>
                <button type="submit" className="btn btn-lg btn-secondary">
                  {t("forms.users.buttons.save")}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

UserForm.propTypes = {
  handleSubmit: PropTypes.func,
  initialValues: PropTypes.object,
  onBack: PropTypes.func,
  edit: PropTypes.bool,
};

const UserFormF = withFormik({
  mapPropsToValues: (props) => {
    if (props.initialValues) {
      return setInitialValues(props.initialValues);
    }
    return dataModel;
  },
  validationSchema: (props) => {
    return validationDataModel(props.edit, props.checkCreate);
  },
  handleSubmit: (values, { props, resetForm }) => {
    props.onSubmit(values, resetForm);
  },
  enableReinitialize: true,
  displayName: "UserForm",
})(UserForm);

export default UserFormF;
